const SET_MIC = 'SET_MIC';
const SET_SHARE_SCREEN = 'SET_SHARE_SCREEN';
const SET_CHAT_ID = 'SET_CHAT_ID';
const SET_HELP_CLICKED = 'SET_HELP_CLICKED';
interface SetMicAction {
  type: typeof SET_MIC;
  mic: boolean;
}
interface SetShareScreenAction {
  type: typeof SET_SHARE_SCREEN;
  shareScreen: boolean;
}

interface SetChatIDAction {
    type: typeof SET_CHAT_ID;
    chatid: string;
}

interface SetHelpClickedAction {
    type: typeof SET_HELP_CLICKED;
    HelpClicked: boolean;
}


export const setMic = (mic: boolean): SetMicAction => {
  return {
    type: SET_MIC,
    mic
  };
};

export const setChatThreadId = (chatid: string): SetChatIDAction => {
    return {
        type: SET_CHAT_ID,
        chatid
    };
};
export const setShareScreen = (shareScreen: boolean): SetShareScreenAction => {
  return {
    type: SET_SHARE_SCREEN,
    shareScreen
  };
};
export const setHelpClicked = (HelpClicked: boolean): SetHelpClickedAction => {
  return {
      type: SET_HELP_CLICKED,
      HelpClicked
  };
};

export { SET_MIC, SET_SHARE_SCREEN, SET_HELP_CLICKED };

export type ControlTypes = SetMicAction | SetShareScreenAction | SetHelpClickedAction;
